import React, { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPackagingHistoryList } from '../../redux/actions/packaging_history.action';
import Paginate from '../../components/Paginate';
import { dateFormat } from '../../utils';

export default function PackagingHistoryPage() {
    const histories = useSelector(state => state.packagingHistoryList);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(getPackagingHistoryList(location, navigate));
    }, [location, dispatch, navigate]);

    return (
        <HelmetProvider>
            <Helmet>
                <title>Historique - Société Mikalo</title>
            </Helmet>

            <div className='title'>
                <h1>Historique</h1>
            </div>

            <div className='box'>
                <table className='table table-striped'>
                    <thead>
                        <tr>
                            <th width="100">Date</th>
                            <th>Nom du packaging</th>
                            <th width="100" className="text-center">Opération</th>
                            <th className="text-center">Quantité</th>
                        </tr>
                    </thead>
                    <tbody>
                        { histories.loading && <tr><td colSpan={ 4 }>Chargement...</td></tr> }
                        { histories.loading === false && histories.data && histories.data.total === 0 && <tr><td colSpan={ 4 }>Aucun élément trouvé</td></tr> }
                        { histories.loading === false && histories.data && histories.data.data && histories.data.data.map((item, index) => {
                        return (
                        <tr key={ index }>
                            <td>{ dateFormat(item.date) }</td>
                            <td>{ item.packaging.code + " - " + item.packaging.name }</td>
                            <td className="text-center">{ item.type === 'IN' ? <span className='badge bg-success'>Entrée</span> : <span className='badge bg-danger'>Sortie</span> }</td>
                            <td className="text-center">{ item.quantity }</td>
                        </tr> ) })}
                    </tbody>
                </table>
            </div>
            
            { histories && histories.data &&
            <Paginate currentPage={ histories.data.current_page } totalPages={ histories.data.last_page } pathname={ location.pathname } search={ location.search } /> }
        </HelmetProvider>
    )
}
